var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_359_2513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.24 68.8L68.8 48L36.24 27.2V68.8ZM48 96C41.4134 96 35.2 94.74 29.36 92.22C23.52 89.7 18.4267 86.2667 14.08 81.92C9.73332 77.5733 6.3 72.48 3.78 66.64C1.26 60.8 0 54.5866 0 48C0 41.36 1.26 35.12 3.78 29.28C6.3 23.44 9.73332 18.36 14.08 14.04C18.4267 9.72 23.52 6.3 29.36 3.78C35.2 1.26 41.4134 0 48 0C54.64 0 60.88 1.26 66.72 3.78C72.56 6.3 77.64 9.72 81.96 14.04C86.28 18.36 89.7 23.44 92.22 29.28C94.74 35.12 96 41.36 96 48C96 54.5866 94.74 60.8 92.22 66.64C89.7 72.48 86.28 77.5733 81.96 81.92C77.64 86.2667 72.56 89.7 66.72 92.22C60.88 94.74 54.64 96 48 96Z",
    fill: "#FF4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_359_2513",
    x: -3.07778,
    y: -3.07778,
    width: 102.156,
    height: 102.156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.53889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_359_2513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_359_2513",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.5622460598b94555ed9c88b9299814be.svg";
export { ForwardRef as ReactComponent };